module.exports = __webpack_public_path__ + "img/balance.51420d19.png";